<template>
  <v-row id="selectObligations" column class="px-2">
    <v-dialog
      :content-class="
        $vuetify.breakpoint.smAndDown ? '' : 'dialog-select-obligations'
      "
      :value="showDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      :width="800"
      @input="cancelDialog"
      :scrollable="true"
    >
      <v-card>
        <v-app-bar dark flat color="primary">
          <v-toolbar-items @click="cancelDialog">
            <v-icon>arrow_back</v-icon>
          </v-toolbar-items>
          <v-toolbar-title>
            {{ resx.labels.selectObligations }}
          </v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          <v-text-field
            :label="resx.labels.search"
            append-icon="search"
            v-model="filter"
            :clearable="true"
          />
          <v-list dense v-if="obligations && obligations.length > 0">
            <v-list-item
              ripple
              v-for="obligation in filteredObligations"
              :key="obligation._id"
              @click.capture.stop="toggleObligation(obligation)"
            >
              <v-list-item-action>
                <v-checkbox
                  v-model="tempValue"
                  :value="obligation"
                  :value-comparator="obligationCompare"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  >{{ obligation.name }} -
                  {{ resx.labels[obligation.dueDateType] }}
                  </v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-col
            v-if="!obligations || obligations.length == 0"
            class="text-xs-center"
          >
            {{ resx.messages.noDataAvailable }}
          </v-col>
          <v-col
            v-if="
              filteredObligations && filteredObligations.length == 0 && filter
            "
            class="text-xs-center"
          >
            {{ resx.messages.noMatchingRecordsFound }}
          </v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveDialog">
            {{ resx.labels.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row row align-center>
      <v-col class="caption grey--text text--darken-2">{{
        resx.labels.obligations
      }}</v-col>
      <v-col shrink>
        <v-btn color="primary" small text @click="openDialog">
          {{ `${resx.labels.add} / ${resx.labels.edit}` }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="value && value.length > 0" row wrap class="chips-row">
      <v-chip
        v-for="obligation in sortedValue"
        :key="obligation._id"
        close
        class="ma-1"
        @click:close="removeChip(obligation)"
      >
        <span class="text-truncate">{{ obligation.name }}</span>
      </v-chip>
    </v-row>
  </v-row>
</template>

<script>
"use strict";

export default {
  name: "selectObligations",
  computed: {
    filteredObligations() {
      if (!this.filter) {
        return this.obligations;
      }
      return this.obligations.filter(obligation =>
        obligation.name.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
    sortedValue() {
      let sorted = [];
      if (this.value && this.value.length > 0) {
        sorted = this.value
          .slice(0)
          .sort((a, b) =>
            a.name.localeCompare(b.name, "en", { sensitivity: "base" })
          );
      }

      return sorted;
    }
  },
  data() {
    return {
      showDialog: false,
      filter: null,
      tempValue: []
    };
  },
  methods: {
    openDialog() {
      this.tempValue = this.value ? this.value.slice() : [];
      this.showDialog = true;
    },
    cancelDialog() {
      this.showDialog = false;
      this.filter = null;
    },
    saveDialog() {
      this.$emit("input", this.tempValue.slice());
      this.showDialog = false;
      this.filter = null;
    },
    removeChip(obligation) {
      const newValue = this.value.filter(obl => obl._id !== obligation._id);
      this.$emit("input", newValue);
    },
    toggleObligation(obligation) {
      const idx = this.tempValue.findIndex(obl => obl._id == obligation._id);
      if (idx >= 0) {
        this.tempValue.splice(idx, 1);
      } else {
        this.tempValue.push(obligation);
      }
    },
    obligationCompare(val1, val2) {
      const result =
        typeof val1 != "undefined" &&
        typeof val2 != "undefined" &&
        val1._id == val2._id;
      return result;
    }
  },
  props: {
    value: { type: Array },
    obligations: { type: Array }
  }
};
</script>

<style lang="scss">
.dialog-select-obligations {
  height: 90%;
}

#selectObligations {
  .chips-row {
    margin-top: 4px;
  }

  .v-chip {
    max-width: 100%;
  }

  .v-chip__content {
    max-width: 100%;
  }
}
</style>
